module.exports = __webpack_public_path__ + "static/img/3areaA_10.25b6ee4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/3areaA_10.png
// module id = 1032
// module chunks = 1